import { useEffect, useRef } from 'react'

const useInfiniteScroll = (callback: () => void) => {
  const ref = useRef<HTMLElement>()

  useEffect(() => {
    const node = ref.current

    const handleScroll = () => {
      const remainingPx = node.scrollHeight - node.clientHeight - node.scrollTop
      if (remainingPx <= 100) {
        callback && callback()
      }
    }

    node.addEventListener('scroll', handleScroll)
    return () => node.removeEventListener('scroll', handleScroll)
  }, [callback])

  return ref
}

export default useInfiniteScroll
